/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Lines_LabelInputs */

const en_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Lines Per Event`)
};

const fr_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre max de lignes par evenement`)
};

const de_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeilen pro Veranstaltung`)
};

const it_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di linee per evento`)
};

const ru_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество линий на мероприятие`)
};

const es_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de líneas por evento`)
};

const zh_cn2_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每场比赛最多行数`)
};

const ja_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントあたりの最大行数`)
};

const hi_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति इवेंट अधिकतम लाइनें`)
};

const pt_pt2_plain_text_import_max_lines_label = /** @type {(inputs: Plain_Text_Import_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de linhas por evento`)
};

/**
* | output |
* | --- |
* | "Max Lines Per Event" |
*
* @param {Plain_Text_Import_Max_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_lines_label = /** @type {((inputs?: Plain_Text_Import_Max_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_max_lines_label(inputs)
	if (locale === "de") return de_plain_text_import_max_lines_label(inputs)
	if (locale === "it") return it_plain_text_import_max_lines_label(inputs)
	if (locale === "ru") return ru_plain_text_import_max_lines_label(inputs)
	if (locale === "es") return es_plain_text_import_max_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_max_lines_label(inputs)
	if (locale === "ja") return ja_plain_text_import_max_lines_label(inputs)
	if (locale === "hi") return hi_plain_text_import_max_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_max_lines_label(inputs)
	return en_plain_text_import_max_lines_label(inputs)
});